enum TipoTitulo {
  PAGAMENTO = 'CP',
  RECEBIMENTO = 'CR'
}

export default TipoTitulo
